export default __webpack_public_path__ + "static/media/logo.3fd87708.png";